import Vue from 'vue'
import VueRouter from 'vue-router'
import NavBar from '../components/NavBar.vue'
import Layout from '../views/layout/layout'
import Login from '../views/login/login'
import NoFunction from '../views/layout/noFunction'
import OriginModule from '../views/layout/originModule'

import patient from './patient'
import baogao from './baogao'
import guahao from './guahao'
import hospital from './hospital'
import hospitalization from './hospitalization'
import menzhenjiaofei from './menzhenjiaofei'
import tijian from './tijian'

Vue.use(VueRouter)

const routes = [
  // 主页
  {
    path: '/',
    name: 'layout',
    meta: { title: '首页' },
    component: Layout

  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: Login
  },
  {
    path: '/noFunction',
    name: 'noFunction',
    meta: { title: '暂不开放' },
    component: NoFunction
  },
  {
    path: '/originModule',
    name: 'originModule',
    meta: { title: '关怀模式' },
    component: OriginModule
  },
  {
    path: '/',
    redirect: '/layout',
    component: NavBar,
    children: [
      ...patient,
      ...baogao,
      ...guahao,
      ...hospital,
      ...hospitalization,
      ...menzhenjiaofei,
      ...tijian
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 记录来源路由到目标路由的 meta 中
  to.meta.from = from
  next()
})

export default router
